import { RoundIntegrityWatcher, RoundIntegrityWatcherPhases } from '../../../logger/RoundIntegrityWatcher';
import type { CoreStoreType } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import type { WinnerType } from '../../../store/slices/game/types';
import { crossOriginCommunicationController } from '../../crossOriginCommunication/CrossOriginCommunicationControllerConnector';
import { OutgoingMessage } from '../../crossOriginCommunication/types';
import type { GameCommunicationMessageType, IGameCommunicationProcessor } from '../types';

export interface WinnersMessage extends GameCommunicationMessageType {
  table: string;
  totalEur: string;
  winner: WinnerType[];
  winnersCount: string;
}

export class GameCommunicationWinnersProcessor implements IGameCommunicationProcessor {
  messageName = 'winners';

  process(message: WinnersMessage, store: CoreStoreType): void {
    RoundIntegrityWatcher.setPhase(RoundIntegrityWatcherPhases.WinnersPaid);

    let winnersList = Array.isArray(message.winner) ? message.winner : [message.winner];
    winnersList = winnersList.filter((item) => item.win > 0);
    store.dispatch(gameStateActions.setWinners(winnersList));
    const total = Number.parseFloat(message.totalEur);
    const totalString = total && !Number.isNaN(total) ? (total > 100 ? total.toFixed(0) : total.toFixed(2)) : '';
    store.dispatch(gameStateActions.setWinnersTotal({ totalEur: totalString, winnersCount: message.winnersCount }));

    crossOriginCommunicationController.dispatch(OutgoingMessage.RoundEnd);
  }
}
